import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=9773da38"
import script from "./restaurant.vue?vue&type=script&lang=js"
export * from "./restaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports